import { Icon } from '@chakra-ui/icons';

export const GlobeWhiteIcon = ({ color = 'action' }: { color?: string }) => (
	<Icon
		width="17px"
		height="17px"
		viewBox="0 0 17 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M16.1216 8.54675C16.1216 12.6889 12.7637 16.0468 8.62158 16.0468M16.1216 8.54675C16.1216 4.40462 12.7637 1.04675 8.62158 1.04675M16.1216 8.54675H1.12158M8.62158 16.0468C4.47945 16.0468 1.12158 12.6889 1.12158 8.54675M8.62158 16.0468C8.62158 16.0468 11.9549 13.5468 11.9549 8.54675C11.9549 3.54675 8.62158 1.04675 8.62158 1.04675M8.62158 16.0468C8.62158 16.0468 5.28825 13.5468 5.28825 8.54675C5.28825 3.54675 8.62158 1.04675 8.62158 1.04675M1.12158 8.54675C1.12158 4.40462 4.47945 1.04675 8.62158 1.04675"
			stroke="white"
			strokeWidth="1.5"
		/>
	</Icon>
);
